export function groupPermissionsByModule(permissions = []) {
    const groups = permissions.reduce((acc, permission) => {
        const moduleKey = permission.module || 'general';
        if (!acc[moduleKey]) {
            acc[moduleKey] = [];
        }
        acc[moduleKey].push(permission);
        return acc;
    }, {});

    return Object.entries(groups)
        .sort(([a], [b]) => a.localeCompare(b))
        .map(([module, items]) => ({
            module,
            label: formatModuleLabel(module),
            permissions: [...items].sort((left, right) => left.permission_key.localeCompare(right.permission_key)),
        }));
}

export function formatModuleLabel(value = '') {
    return String(value)
        .replace(/([a-z])([A-Z])/g, '$1 $2')
        .replace(/[_-]+/g, ' ')
        .replace(/\b\w/g, (char) => char.toUpperCase());
}

export function splitOverrides(overrides = []) {
    return overrides.reduce(
        (acc, item) => {
            if (item.granted) {
                acc.grants.push(String(item.permissionid));
            } else {
                acc.denies.push(String(item.permissionid));
            }
            return acc;
        },
        { grants: [], denies: [] }
    );
}

export function buildOverrides(grants = [], denies = []) {
    const denySet = new Set((denies || []).map(String));
    const grantSet = new Set((grants || []).map(String).filter((id) => !denySet.has(id)));

    return [
        ...Array.from(grantSet).map((permissionid) => ({ permissionid, granted: true })),
        ...Array.from(denySet).map((permissionid) => ({ permissionid, granted: false })),
    ];
}
